import {DefaultErrorOverlay} from '@ael/shared-components-library';
import React from 'react';

export const UnknownLoadingErrorOverlay = () => {
  return (
    <DefaultErrorOverlay
      title="Unknown error"
      description={<p>We have detected an unknown error when communicating with server.</p>}
    />
  );
};
